import classNames from 'classnames';

import { Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';
import { syntheticOpen, WindowTargets } from '@src/helpers/synteticOpen';

import styles from './FullDealEntryPointDisclaimer.module.scss';

export function FullDealEntryPointDisclaimer({ className, link }: { className?: string; link: string }) {
  const isMobile = useIsMobile();

  const handleClick = () => {
    syntheticOpen({
      href: link,
      target: WindowTargets.BLANK_NO_OPENER,
    });
  };

  if (isMobile) {
    return (
      <Text className={classNames(styles.disclaimer, className)}>
        Организатор акции: ООО МКК «А Деньги». Акция «Первый заём бесплатно». Срок{UNBREAKABLE_SEPARATOR}проведения
        акции с{UNBREAKABLE_SEPARATOR}14.03.2023 по 31.12.2026 г. <br /> Подробности о порядке и{UNBREAKABLE_SEPARATOR}
        условиях проведения акции <br /> опубликованы на <a onClick={handleClick}>сайте</a>
      </Text>
    );
  }

  return (
    <Text className={classNames(styles.disclaimer, className)}>
      Организатор акции: ООО МКК «А Деньги». Акция «Первый заём бесплатно». Срок{UNBREAKABLE_SEPARATOR}проведения акции
      с{UNBREAKABLE_SEPARATOR}14.03.2023 по 31.12.2026 г.
      <br />
      Подробности о порядке и{UNBREAKABLE_SEPARATOR}условиях проведения акции опубликованы на{' '}
      <a onClick={handleClick}>сайте</a>
    </Text>
  );
}
